/**
 * Fix carousel scroll position on page load/refresh
 * Forces all carousels to start at the first slide
 */

(function() {
  'use strict';

  // Disable browser scroll restoration for carousel sections
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function resetCarouselScrollPositions() {
    // Find all carousel containers
    const carousels = document.querySelectorAll('.resource-list__carousel slideshow-slides, slideshow-component slideshow-slides');
    
    carousels.forEach((carousel) => {
      // Force scroll to start (left: 0)
      carousel.scrollLeft = 0;
    });
  }

  // Run immediately
  resetCarouselScrollPositions();

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetCarouselScrollPositions);
  }

  // Run after a short delay to catch any late-loading carousels
  setTimeout(resetCarouselScrollPositions, 100);
  setTimeout(resetCarouselScrollPositions, 300);

  // Watch for new carousels being added
  const observer = new MutationObserver((mutations) => {
    let hasNewCarousels = false;
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && (
            node.classList?.contains('resource-list__carousel') ||
            node.querySelector?.('.resource-list__carousel')
          )) {
            hasNewCarousels = true;
          }
        });
      }
    });
    
    if (hasNewCarousels) {
      setTimeout(resetCarouselScrollPositions, 50);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also reset on page show (when navigating back/forward)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      // Page was restored from bfcache
      resetCarouselScrollPositions();
    }
  });
})();
